import React from 'react';
import { useTranslation } from 'react-i18next';
import { Style } from './style';
import config from './config';
import { Tooltip, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

const { Paragraph } = Typography;

const Roaster = ({
  data = null,
  projectData = {},
  defaultSources = 0,
  allData = {},
}) => {
  const { t } = useTranslation();
  const loading = !data;
  const { user } = useSelector((state) => state.authentication);

  const _proj = (user?.settings?.projects || []).find((p) => p?.id === projectData?.id)
  const sources = Array.isArray(_proj?.visualisation?.supplyChainInformationSources) ?
    _proj?.visualisation?.supplyChainInformationSources.length :
    defaultSources;

  const _render = (key) => {
    const label = t(config[key]?.label);
    let value = data ? Number(data[key] || 0).toLocaleString() : '0';

    switch (key) {
      case 'sources':
        value = sources;
        break;
      case 'documents':
        value = allData?.uniqueInformationSubjects?.documents?.totalItems ?
          Number(allData?.uniqueInformationSubjects?.documents?.totalItems).toLocaleString() : '0';
        break;
      default:
    }

    return (
      <div key={`left-${key}`} className="row-item">
        <div className="icon-cont">
          <div className="icon">
            <img src={config[key]?.source} alt="img" />
          </div>
        </div>
        <label className="value">
          {loading ? <LoadingOutlined /> : value}
        </label>
        <Tooltip title={label}>
          <Paragraph className="label" ellipsis={label}>
            {label}
          </Paragraph>
        </Tooltip>
      </div>
    );
  };

  return (
    <Style className="dds-roaster">
      {Object.keys(config).map((key) => _render(key))}
    </Style>
  );
};

export default Roaster;
